import { createCrudActions } from "../utils/crudGenerator";

const formatObjects = (data) => {
  if (!data) {
    return [];
  }
  const formatItem = (item) => ({
    ...item,
    label: `${item.name}`,
    value: item._id,
  });

  if (Array.isArray(data)) {
    return data.map(formatItem);
  }
  return formatItem(data);
};

export const {
  fetch: fetchObjects,
  create: createObject,
  update: updateObject,
  delete: deleteObjects,
} = createCrudActions("OBJECT", "Objeto", formatObjects);
